import {
    Dialog,
    BUTTON_VARIANTS,
  } from 'cdk-radial';
  import styled from 'styled-components';
  import { useTranslation } from 'react-i18next';
  import { useTheme } from '../../contexts/Theme';
  import {useMobileAppLaunchStore} from '../../Store/useMobileAppLaunchStore';
  
  export const StyledDialog = styled(Dialog)`
    min-width: 560px;
    max-width: 30%;
    margin-top: 60px;
    z-index: 9999;
    .izBOLP {
    border-bottom: 0px;
  }
    .lbEdpe {
    padding: 0rem 2rem 0px;
}
    .xzROl {
    justify-content: space-between;
}
    @media (max-width: 570px) {
      min-width: 10vw;
      max-width: 100%;
      width: 92vw;
    }

  `;
  
  export const StyledDialogTitle = styled.div`
    fontweight: 600;
    font-size: 20px;
    line-height: 20px;
    text-transform: capitalize;
    @media (max-width: 570px) {
      font-size: 1.1rem;
    }
    @media (max-width: 510px) {
      font-size: 1rem;
    }
    @media (max-width: 490px) {
      font-size: .9rem;
    }
    @media (max-width: 450px) {
      font-size: .8rem;
    }
    @media (max-width: 400px) {
      font-size: .7rem;
    }
  `;
  
  export const StyledDialogTitleContainer = styled.div`
    flex-direction: row;
    display: flex;
    align-items: center;
  `;
  
  export const StyledDialogContentText = styled.div`
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    padding-top: 10px;
  `;

  export const CardHeader = styled.div`
  font-family: 'Montserrat', 'Roboto', sans-serif;
  display: flex;
  align-items: center;
  gap: 10px 8px;
  font-weight: 600;
  height: 80px;
`;

export const ProductIcon = styled.div<{ iconColor: string }>`
  font-family: 'Montserrat', 'Roboto', sans-serif;
  display: flex;
  padding: 0.16rem;
  align-items: flex-start;
  background-color: ${({ iconColor }) => iconColor};
  border-radius: 2px;
  box-sizing: border-box;
  color: #fff;
  grid-area: 1/1;
  flex-direction: row-reverse;
  flex-wrap: wrap-reverse;
  font-size: 18px;
  font-weight: 400;
  height: 48px;
  letter-spacing: -0.06em;
  line-height: 18px;
  overflow-wrap: anywhere;
  overflow: hidden;
  text-align: end;
  width: 48px;
`;

export const CardTitle = styled.div`
  font-family: 'Montserrat', 'Roboto', sans-serif;
  display: flex;
  flex-direction: column;
  font-size: 16px;
`;

  const GetMobileAppDialog = ( ): JSX.Element => {
    const { t } = useTranslation();
    const { darkMode } = useTheme();
    const setShowDialog = useMobileAppLaunchStore((state:any) => state.setShowDialog);
    const showDialog = useMobileAppLaunchStore((state:any) => state.showDialog);
    const appName = useMobileAppLaunchStore((state:any) => state.appName);
    const appIcon = useMobileAppLaunchStore((state:any) => state.appIcon);
    const appIconColor = useMobileAppLaunchStore((state:any) => state.appIconColor);
    const appDescription = useMobileAppLaunchStore((state:any) => state.appDescription);
    const appDownloadUrl = useMobileAppLaunchStore((state:any) => state.appDownloadUrl);

      const getApp = () => {
        setShowDialog(false);
        window.location.href = appDownloadUrl;
      };

      const onCancel = () => {
        setShowDialog(false);
      };
    

    return (
      <div>
        <StyledDialog
          buttonsProps={[
            {
              id: 'Cancel',
              dataTestId: 'getapp-dialog-cancel',
              onClick: onCancel,
              text: t('getMobileAppDialog.cancelBtn'),
              variant: BUTTON_VARIANTS.TEXT,
              style: {
                color: darkMode ? 'white' : 'black'
              },
            },
            {
              id: 'getapp-dialog-getapp',
              onClick: getApp,
              text: t('getMobileAppDialog.getAppButton')+ appName,
              variant: BUTTON_VARIANTS.PRIMARY,
              style: {
                color: darkMode ? 'black' : 'white',
                backgroundColor: darkMode ? 'white' : 'black',
              },
            },
          ]}
          id="getapp-dialog-getapp-alert"
          data-testid="getapp-dialog-getapp-alert"
          isOpen={showDialog}
          onClose={onCancel}
          title={
            <StyledDialogTitleContainer>
              <StyledDialogTitle>
                {t('getMobileAppDialog.getAppTitle')}
              </StyledDialogTitle>
            </StyledDialogTitleContainer>
          }
        >
            <CardHeader>
              <ProductIcon iconColor={appIconColor} data-testid="app-icon">
                {appIcon || ''}
              </ProductIcon>

            <CardTitle>
              {appName}
            </CardTitle>
          </CardHeader>
            <StyledDialogContentText>
              {appDescription}
            </StyledDialogContentText>
        </StyledDialog>
      </div>
    );
  };
  export default GetMobileAppDialog;
  